
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/db348d46-2fd2-4e26-b6a0-ef8fa9110d33.png" 
              alt="ASELCO S.R.L. Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              ASELCO S.R.L.
            </span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              Products
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
